<template>
  <transition name="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">
            <span>{{ title }}</span>
          </slot>
          <RoundButton v-on:go="$emit('close')" image="ic-cross.svg" class="closeButton" />
        </div>
        <div class="modal-body">
          <p v-html="content"></p>
        </div>
        <!--        <div class="modal-footer">
          <img alt="lire video" class="svgImg" src="../assets/ic-play.svg" width="24" />
          <slot name="footer">Voir la vidéo Varilux®</slot>
        </div>-->
      </div>
    </div>
  </transition>
</template>

<script>
import RoundButton from '@Components/Menus/RoundButton';

export default {
  components: {
    RoundButton,
  },
  props: ['title', 'content'],
};
</script>

<style scoped>
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: absolute;
  color: white;
  width: 424px;
  height: 529px;
  margin: -60px auto;
  padding: 20px 30px;
  background-color: rgba(0, 0, 0, 0.88);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  bottom: 80px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-header span {
  font-family: 'AkhandSoft', Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: bold;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  text-align: left;
}

.modal-body span {
  font-family: 'AkhandSoft', Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: 300;
}

.modal-body li {
  font-family: 'AkhandSoft', Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: 300;
  list-style: none;
}

.modal-body ul {
  padding-left: 20px;
}

.modal-footer {
  margin-top: 20px;
  display: flex;
  font-family: 'AkhandSoft', Helvetica, Arial, sans-serif;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-weight: 300;
}

.modal-default-button {
  float: right;
}

.svgImg {
  margin-right: 20px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.closeButton {
  margin: 0;
}
</style>
